import React from 'react';
import { Link } from 'gatsby';

// styles
import { Container } from '@styles';
import {
  BreadCrumbSection,
  Wrapper,
  Title,
  Page,
  Item,
  ActiveItem,
} from './styles';

const BreadCrumb = ({ name }) => {
  return (
    <BreadCrumbSection>
      <Container normal>
        <Wrapper>
          {name && <Title>{name}</Title>}
          <Page>
            <Item>
              <Link to="/">Home</Link>
            </Item>
            {name && <ActiveItem>{name}</ActiveItem>}
          </Page>
        </Wrapper>
      </Container>
    </BreadCrumbSection>
  );
};

export default BreadCrumb;
